import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Privacy() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-background text-gray-300 p-6 sm:p-10">
      <div className="max-w-3xl mx-auto">
        <button onClick={() => nav(-1)} className="text-sm text-muted-foreground hover:text-white flex items-center gap-1 mb-6"><ArrowLeft className="w-4 h-4" /> Powrót</button>
        <img src="/tmc-logo.png" alt="The Money Club" className="w-14 h-14 rounded-xl border border-primary/40 mb-4" />
        <h1 className="font-head text-3xl font-extrabold text-white mb-6">Polityka prywatności</h1>
        <div className="space-y-4 text-sm leading-relaxed">
          <p>The Money Club szanuje Twoją prywatność. Niniejsza polityka opisuje, jakie dane zbieramy i jak je wykorzystujemy.</p>
          <h2 className="text-white font-semibold text-lg">Jakie dane zbieramy</h2>
          <p>Imię i nazwisko, adres e-mail, nazwę użytkownika oraz ID konta Discord, a także ID konta u brokera partnerskiego (TradeQuo) — podawane podczas weryfikacji i dołączania do społeczności. Zapisujemy również podstawową aktywność związaną z Twoim wnioskiem (status, historia zmian).</p>
          <h2 className="text-white font-semibold text-lg">Jak wykorzystujemy dane</h2>
          <p>Dane służą do weryfikacji członków, nadawania dostępu do społeczności i materiałów oraz do kontaktu w sprawach związanych z Twoim uczestnictwem. Nie sprzedajemy Twoich danych osobom trzecim.</p>
          <h2 className="text-white font-semibold text-lg">Bezpieczeństwo</h2>
          <p>Hasła są przechowywane w formie zaszyfrowanej (hash). Sesje działają na bezpiecznych plikach cookie (httpOnly).</p>
          <h2 className="text-white font-semibold text-lg">Kontakt</h2>
          <p>W sprawach danych osobowych lub jakichkolwiek pytań napisz do nas na Telegramie: <a className="gold-text" href="https://t.me/bwattola" target="_blank" rel="noreferrer">@bwattola</a>.</p>
          <p className="text-xs text-muted-foreground">Trading niesie ryzyko utraty kapitału. The Money Club ma charakter edukacyjny i nie stanowi indywidualnej porady inwestycyjnej.</p>
        </div>
      </div>
    </div>
  );
}
